import React from 'react'
import ReportCalendarMonthPicker from './ReportCalendarMonthPicker'
import '../../styles/report-calendar-sidebar.sass'

const ReportCalendarSidebar = ({
	selectedDate,
	onSelectedDateChange,
	onViewMonthChange,
	events,
	isLoading,
}) => {
	return (
		<div className='reporting-calendar-sidebar'>
			<ReportCalendarMonthPicker
				selectedDate={selectedDate}
				onChange={onSelectedDateChange}
				onViewMonthChange={onViewMonthChange}
				events={events}
				isLoading={isLoading}
			/>
		</div>
	)
}

export default ReportCalendarSidebar
